import { render } from "./Admin.vue?vue&type=template&id=330305e5&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=330305e5&scoped=true&lang=css"

import exportComponent from "D:\\Documents\\MetaLuxe\\projects\\mantaray-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-330305e5"]])

export default __exports__